import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "close-sharp",
  "use": "close-sharp-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"close-sharp\"><path fill-rule=\"evenodd\" d=\"M21 .2 24 3l-9 8.8 8.8 8.8-2.9 2.9-8.8-8.9-8.8 8.9-2.8-2.9 8.8-8.8L.6 3 3.4.2 12.2 9z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol